import { DateTime } from 'luxon';

/**
 * Validates that the date range between startDate and endDate is within the allowed limit.
 * The backend enforces that startDate and endDate cannot be more than 7 days apart.
 */

export const MAX_DATE_RANGE_DAYS = 7;

/**
 * Calculates the difference in days between two date strings
 * @param startDate - Start date in YYYY-MM-DD format
 * @param endDate - End date in YYYY-MM-DD format
 * @returns Number of days between the dates
 */
export const getDaysDifference = (startDate: string, endDate: string): number => {
  const start = DateTime.fromISO(startDate);
  const end = DateTime.fromISO(endDate);
  return Math.abs(end.diff(start, 'days').days);
};

/**
 * Validates if a date range is within the maximum allowed days
 * @param startDate - Start date in YYYY-MM-DD format
 * @param endDate - End date in YYYY-MM-DD format (optional)
 * @returns true if the range is valid, false otherwise
 */
export const isValidDateRange = (startDate: string, endDate?: string | null): boolean => {
  if (!endDate) {
    return true; // If no end date, it's always valid
  }
  
  const daysDiff = getDaysDifference(startDate, endDate);
  return daysDiff <= MAX_DATE_RANGE_DAYS;
};
